import { render, staticRenderFns } from "./Notificator.vue?vue&type=template&id=8aac203c&"
import script from "./Notificator.vue?vue&type=script&lang=js&"
export * from "./Notificator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports